import React from 'react';

export const AdminPeople = () => {
  return <>
    Admin people
  </>
};

